import React from "react";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import WysiwygSimpleEditor from "commons/ui/input/WysiwygSimpleEditor";
import LineSeparator from "commons/ui/LineSeparator";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import AttachmentPicker from "components/ui/AttachmentPicker";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionThreeParagraphs from "hooks/form/blocks/useSectionThreeParagraphs";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { DesktopOrMobile } from "types/enums";

function SectionThreeParagraphsForm() {
    const { buttonDelete, setImageOne, formHook } = useSectionThreeParagraphs();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, setValue, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridColumn>
                        <GridRow alignItems={"end"}>
                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Immagine di Background</h3>
                                    </GridItem>
                                </GridRow>

                                <ExtensionsProporsionInfo
                                    desktopText={"TO DO"}
                                    mobileText={"TO DO"}
                                    proportion={"TO DO"}
                                />

                                <GridRow>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setImageOne(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.img_one.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_one.desktop")}
                                        />
                                    </GridItem>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setImageOne(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.img_one.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_one.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>

                    <LineSeparator />

                    <GridColumn>
                        <GridRow>
                            <GridItem className={"col-xs-12-12"}>
                                <h3>Testi</h3>
                            </GridItem>
                        </GridRow>

                        <GridRow>
                            <GridItem>
                                <span>Inserisci i testi per tutte le lingue</span>
                            </GridItem>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Primo titolo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_1}
                                            setValue={setValue}
                                            path={"text.it.text_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <WysiwygSimpleEditor
                                            label={"Primo testo"}
                                            bigDefault={true}
                                            value={form.text.it.text_2}
                                            path={"text.it.text_2"}
                                            setValue={setValue}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Secondo Titolo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_3}
                                            setValue={setValue}
                                            path={"text.it.text_3"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <WysiwygSimpleEditor
                                            label={"Secondo testo"}
                                            bigDefault={true}
                                            value={form.text.it.text_4}
                                            path={"text.it.text_4"}
                                            setValue={setValue}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Terzo Titolo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_5}
                                            setValue={setValue}
                                            path={"text.it.text_5"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <WysiwygSimpleEditor
                                            label={"Terzo testo"}
                                            bigDefault={true}
                                            value={form.text.it.text_6}
                                            path={"text.it.text_6"}
                                            setValue={setValue}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Primo Titolo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_1}
                                            setValue={setValue}
                                            path={"text.en.text_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <WysiwygSimpleEditor
                                            label={"Primo testo"}
                                            bigDefault={true}
                                            value={form.text.en.text_2}
                                            path={"text.en.text_2"}
                                            setValue={setValue}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Secondo Titolo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_3}
                                            setValue={setValue}
                                            path={"text.en.text_3"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <WysiwygSimpleEditor
                                            label={"Secondo testo"}
                                            bigDefault={true}
                                            value={form.text.en.text_4}
                                            path={"text.en.text_4"}
                                            setValue={setValue}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Terzo Titolo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_5}
                                            setValue={setValue}
                                            path={"text.en.text_5"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <WysiwygSimpleEditor
                                            label={"Terzo testo"}
                                            bigDefault={true}
                                            value={form.text.en.text_6}
                                            path={"text.en.text_6"}
                                            setValue={setValue}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionThreeParagraphsForm;
